import React from 'react';
import { useRef } from 'react';
import '@/css/Variation.css'

type ModalProps = {
  isJoinMatchModalOpen: boolean;
  onClose: () => void;
};

const JoinPrivateMatchModal: React.FC<ModalProps> = ({ isJoinMatchModalOpen, onClose }) => {
    const inputsRef = useRef<Array<HTMLInputElement | null>>([]); // ✅ Now called unconditionally
  
    if (!isJoinMatchModalOpen) return null;
  
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, idx: number) => {
    const value = e.target.value;

    // If a digit was entered and not empty, go to next input
    if (value && idx < 5) {
      inputsRef.current[idx + 1]?.focus();
    }

    // Optional: prevent non-digit input
    if (!/^[0-9]?$/.test(value)) {
      e.target.value = '';
    }
  };
  return (
    <div className="popup fadeout">
    <div className="popup closeLayer"></div>
    <div className="container">
    <div style={{ display: 'flex',justifyContent: 'space-between'}}>
        <h3>Join Private Session</h3>
        <button onClick={onClose}>
            <svg width={15} aria-hidden="true" style={{ color: '236,240,241' }} focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path></svg>
        </button>
     </div>
      <div className="modalItemContainer">
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            {Array.from({ length: 6 }).map((_, i) => (
                <input
                    key={i}
                    type="text"
                    maxLength={1}
                    className="code-input"
                    inputMode="numeric"
                    ref={el => {
                    inputsRef.current[i] = el;
                    }}
                    onChange={e => handleChange(e, i)}
                />
            ))}
        </div>

        <button className="submit-button">Join Match</button>

      </div>
    </div>
  </div>
  );
};

export default JoinPrivateMatchModal;
